import { render, staticRenderFns } from "./CorridorAwarenessLocations.vue?vue&type=template&id=38b1f150&scoped=true&"
import script from "./CorridorAwarenessLocations.vue?vue&type=script&lang=js&"
export * from "./CorridorAwarenessLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b1f150",
  null
  
)

export default component.exports